import { createRouter, createWebHistory } from 'vue-router';
import IncomePage from '../views/IncomePage.vue';
import ExpensePage from '../views/ExpensePage.vue';
import LoginPage from '../views/LoginPage.vue';
import RegisterPage from '../views/RegisterPage.vue';
import ReportPage from '../views/ReportPage.vue';
import UserManagementPage from '../views/UserManagementPage.vue'; 

const routes = [
  {
    path: '/',
    redirect: '/income' // Default ke halaman login
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/income',
    name: 'Income',
    component: IncomePage,
    meta: { requiresAuth: true } // Lindungi rute ini
  },
  {
    path: '/expense',
    name: 'Expense',
    component: ExpensePage,
    meta: { requiresAuth: true } // Lindungi rute ini
  },
  {
    path: '/report',
    name: 'Report',
    component: ReportPage,
    meta: { requiresAuth: true } // Pastikan hanya bisa diakses setelah login
  },
  {
    path: '/admin/users', // Rute untuk manajemen user
    name: 'UserManagement',
    component: UserManagementPage,
    meta: { requiresAuth: true, requiredRole: 'owner' } // Hanya admin yang bisa akses
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  let isAuthenticated = !!token;
  let userRole = null;

  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.role) {
      userRole = user.role;
    }
  } catch (e) {
    console.error("Failed to parse user data from localStorage", e);
  }

  // Periksa apakah rute membutuhkan autentikasi
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login'); // Redirect ke halaman login jika tidak terautentikasi
  }
  // Periksa apakah rute membutuhkan role admin
  else if (to.meta.requiresAdmin && userRole !== 'admin' && userRole !== 'owner') {
    alert('Akses Ditolak: Hak akses admin diperlukan.');
    next('/'); // Redirect ke dashboard atau halaman lain
  }
  // Lanjutkan navigasi
  else {
    next();
  }
});

export default router;
